var arr = [];
var each = arr.forEach;
var slice = arr.slice;


module.exports = function(obj) {
    each.call(slice.call(arguments, 1), function(source) {
        if (source) {
            for (var prop in source) {
                obj[prop] = source[prop];
            }
        }
    });
    return obj;
};



//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/extend-object/extend-object.js
// module id = 591
// module chunks = 2